import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-black text-white px-6 py-4 flex justify-between items-center shadow-md fixed w-full z-50 top-0 left-0">
      <div className="text-2xl font-bold text-orange-500">Karangou Studios</div>

      {/* Burger menu */}
      <div className="md:hidden">
        <button
          className="focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Menu links */}
      <div className={`md:flex space-x-6 ${menuOpen ? "block mt-4" : "hidden md:block"}`}>
        <Link to="/" className="hover:text-orange-500">Accueil</Link>
        <Link to="/films" className="hover:text-orange-500">Films + Projets</Link>
      </div>
    </nav>
  );
}
